// authSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getcategoryRecord } from "../../../Api/api";

// Define an initial state for the slice
const initialState = {
   data: null,
   loading: false,
   error: null,
};



// Create an async thunk for the login action
export const categoryMasterSingleListAsync = createAsyncThunk(
   "tonnageMaster/getList",
   async ({ data, done, err }) => {
      // ;
      try {
         const { id} = data;
       //  const response = await handleCompanyMasterSingleList(id, modelId, actionId);
         const response = await getcategoryRecord(id);
         done && done(response.data.res);
         return response.data;
      } catch (error) {
         // You can customize the error handling here
         
         err && err();
         throw error.response.data;
      }
   }
);

// Create a slice of the Redux store
const categoryMasterSingleListSlice = createSlice({
   name: "tonnageMaster",
   initialState,
   reducers: {
      // You can define additional synchronous actions here if needed
   },
   extraReducers: (builder) => {
      builder
         .addCase(categoryMasterSingleListAsync.pending, (state) => {
            state.loading = true;
            state.error = null;
         })
         .addCase(categoryMasterSingleListAsync.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            // 
         })
         .addCase(categoryMasterSingleListAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload; // error message from the rejectWithValue call
         });
   },
});

// Export the reducer
export default categoryMasterSingleListSlice.reducer;
